<template>
	<div class="log">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0" v-if="filtershow">
					<el-form-item label="">
						<el-input v-model="formfilter.keyword" placeholder="渠道代码/渠道名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column label="渠道名称/渠道代码/qq" align="center" header-align="center" min-width="130px" fixed="left">
						<template slot-scope="scope">
							<div>{{scope.row.name}}</div>
							<div>{{scope.row.code}}</div>
							<!-- <div>{{scope.row.qq}}</div> -->
							<div class="simg">
								<el-tooltip :content="scope.row.qq" placement="bottom" effect="light">
									<img src="../../assets/image/qq.png" @click="oncopy(scope.row.qq)">
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="score" label="评分" align="center" header-align="center" width="60px">
					</el-table-column>
					<el-table-column prop="available_delivery_date_str" label="下单日" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column label="截止接单" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							<span>{{scope.row.stop_take_hour}}</span>:
							<span>{{scope.row.stop_take_minute}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="delivery_time_str" label="发货时间" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column label="允许退货比例" align="center" header-align="center" min-width="70px">
						<template slot-scope="scope">
							<span>{{scope.row.free_return_rate}}%</span>
						</template>
					</el-table-column>
					<el-table-column label="超比例扣费" align="center" header-align="center" min-width="60px">
						<template slot-scope="scope">
							<span>{{scope.row.exceed_rate_deduct}}%</span>
						</template>
					</el-table-column>
					<el-table-column prop="after_service_day_number" label="售后自动处理天数" align="center" header-align="center" width="90px">
					</el-table-column>
					<el-table-column label="配货率" align="center" header-align="center" width="70px">
						<template slot-scope="scope">
							<span>{{scope.row.allocation_rate}}%</span>
						</template>
					</el-table-column>
					<el-table-column label="准时率" align="center" header-align="center" width="70px">
						<template slot-scope="scope">
							<span>{{scope.row.on_time_rate}}%</span>
						</template>
					</el-table-column>
					<el-table-column prop="return_notice" label="退货注意事项" align="center" header-align="center" min-width="90px">
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" width="90px" fixed="right">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="onxz(scope.row)">库存下载</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'shoprank',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					keyword: ""
				},
				resizeObserver: null
			}
		},
		
		mounted() {
			this.onlist();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		inject: ['oncopy'],
		
		methods: {
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					keyword: ""
				};
				this.page = 1;
				this.onlist();
			},
			
			handleCurrentChange() {
				this.onlist();
			},
					
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			
			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;
				this.$axios.post('api/user/shop_rank', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			onxz(val) {
				var obj = {
					shop_id: val.id
				};
				this.$axios.post('api/user/shop_stock_export2', obj).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.log {
		height: 100%;
	}
	
	.tablebox {
		height: calc(100% - 72px);
	}
	
	.simg {
		width: 100%;
		display: flex;
		justify-content: center;
	
		img {
			width: 25px;
			height: 25px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/buyer/shoprank.vue